export default "__VITE_ASSET__BpAcR3dx__"